import * as api from '../../api'
// import moment from 'moment'
import * as types from '../../mutation-types'
import router from '../../../router'
import moment from 'moment/moment'

let twelveHourFormat = 'hh:mm:ss a'
let twentyFourHourFormat = 'HH:mm:ss'

const state = {
  backup_frequencies: [],
  backup_location_types: [],
  backup_location: {},
  backup_locations: [],
  backup_locations_received_timestamp: new Date(0),
  backup_schedule: {},
  backup_schedules: [],
  backup_schedules_received_timestamp: new Date(0)
}

const getters = {
  allBackupFrequencies: state => state.backup_frequencies,
  allBackupLocationTypes: state => state.backup_location_types,
  singleBackupLocation: state => state.backup_location,
  allBackupLocations: state => state.backup_locations,
  singleBackupSchedule: state => state.backup_schedule,
  allBackupSchedules: state => state.backup_schedules
}

const actions = {
  getBackupFrequencies ({ commit }) {
    if (!Array.isArray(state.backup_frequencies) || !state.backup_frequencies.length) {
      api.instance.get('backup_frequencies')
        .then(function (response) {
          const backupFrequencies = response.data.backup_frequencies
          commit(types.RECEIVE_BACKUP_FREQUENCIES, backupFrequencies)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  getBackupLocationTypes ({ commit }) {
    if (!Array.isArray(state.backup_location_types) || !state.backup_location_types.length) {
      api.instance.get('backup_location_types')
        .then(function (response) {
          const backupLocationTypes = response.data.backup_location_types
          commit(types.RECEIVE_BACKUP_LOCATION_TYPES, backupLocationTypes)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  getBackupLocation ({ commit }, backupLocationId) {
    api.instance.get('backup_locations/' + backupLocationId)
      .then(function (response) {
        const backupLocation = response.data.backup_location
        commit(types.RECEIVE_BACKUP_LOCATION, backupLocation)
      })
  },
  getBackupLocations ({ commit }) {
    const diff = Math.abs(new Date(state.backup_locations_received_timestamp) - new Date())
    const diffMinutes = Math.floor((diff / 1000) / 60)
    if (diffMinutes >= 1) {
      api.instance.get('backup_locations')
        .then(function (response) {
          const backupLocations = response.data.backup_locations
          commit(types.RECEIVE_BACKUP_LOCATIONS, backupLocations)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  addEditBackupLocation ({ commit }, backupLocation) {
    // verify data
    if (backupLocation.name === '') {
      alert('Name is a required field.')
      return
    }

    if (backupLocation.path === '') {
      if (backupLocation.storage_device === '0' || !backupLocation.storage_device) {
        alert('Path is a required field.')
        return
      }
    }

    if ([2, 3].includes(backupLocation.backup_location_type_id)) {
      if (backupLocation.server === '') {
        alert('Server is a required field.')
        return
      }

      if (backupLocation.backup_location_type_id === 3) {
        if (backupLocation.username === '' ||
          backupLocation.password === '') {
          alert('Username and password are required fields for FTP locations.')
          return
        }
      }
    }

    if (backupLocation.backup_location_id === 0) {
      if (backupLocation.storage_device !== '0') {
        backupLocation.path = backupLocation.storage_device + '/' + backupLocation.path
      }

      api.instance.post('backup_locations', backupLocation)
        .then(function (response) {
          if (response.data.success === 'true') {
            backupLocation.backup_location_type = state.backup_location_types.filter(function (el) {
              if (el.backup_location_type_id === backupLocation.backup_location_type_id) {
                return true
              }
            })[0]
            backupLocation.backup_location_id = response.data.backup_location[0].backup_location_id
            commit(types.ADD_BACKUP_LOCATION, backupLocation)
            router.push({ name: 'AdminBARLocationsIndex' })
          } else {
            alert(response.data.message)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    } else {
      api.instance.put('backup_locations/' + backupLocation.backup_location_id, backupLocation)
        .then(function (response) {
          if (response.data.success === 'true') {
            backupLocation.backup_location_type = state.backup_location_types.filter(function (el) {
              if (el.backup_location_type_id === backupLocation.backup_location_type_id) {
                return true
              }
            })[0]
            commit(types.EDIT_BACKUP_LOCATION, backupLocation)
            router.push({ name: 'AdminBARLocationsIndex' })
          } else {
            alert(response.data.message)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  deleteBackupLocation ({ commit }, backupLocation) {
    api.instance.delete('backup_locations/' + backupLocation.backup_location_id)
      .then(function (response) {
        commit(types.DELETE_BACKUP_LOCATION, backupLocation)
      })
  },
  getBackupSchedule ({ commit }, backupScheduleId) {
    if (backupScheduleId === 0) {
      commit(types.RECEIVE_BACKUP_SCHEDULE, {
        backup_schedule_id: 0,
        backup_frequency_id: 3,
        backup_location_id: 0,
        name: '',
        enabled: true,
        schedule_time_formatted: moment('10:00:00 am', twelveHourFormat).format(twelveHourFormat)
      })
    } else {
      api.instance.get('backup_schedules/' + backupScheduleId)
        .then(function (response) {
          const backupSchedule = response.data.backup_schedule
          let tempScheduleTime = moment(backupSchedule.schedule_time, [twentyFourHourFormat])
          backupSchedule.schedule_time_formatted = tempScheduleTime.format(twelveHourFormat)
          commit(types.RECEIVE_BACKUP_SCHEDULE, backupSchedule)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  getBackupSchedules ({ commit }) {
    const diff = Math.abs(new Date(state.backup_schedules_received_timestamp) - new Date())
    const diffMinutes = Math.floor((diff / 1000) / 60)
    if (diffMinutes >= 1) {
      api.instance.get('backup_schedules')
        .then(function (response) {
          const backupSchedules = response.data.backup_schedules

          for (let i = 0; i < backupSchedules.length; i++) {
            backupSchedules[i].schedule_time = moment(backupSchedules[i].schedule_time, [twentyFourHourFormat]).format(twelveHourFormat)
          }

          commit(types.RECEIVE_BACKUP_SCHEDULES, backupSchedules)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  addEditBackupSchedule ({ commit }, backupSchedule) {
    if (backupSchedule.name !== '') {
      if (backupSchedule.backup_location_id !== 0 && backupSchedule.backup_location_id !== '0') {
        if (moment(backupSchedule.schedule_time_formatted, [twelveHourFormat])._isValid) {
          backupSchedule.schedule_time = moment(backupSchedule.schedule_time_formatted, [twelveHourFormat]).format(twentyFourHourFormat)
          if (backupSchedule.backup_schedule_id === 0) {
            api.instance.post('backup_schedules', {
              backup_schedule_id: backupSchedule.backup_schedule_id,
              backup_frequency_id: backupSchedule.backup_frequency_id,
              backup_location_id: backupSchedule.backup_location_id,
              name: backupSchedule.name,
              enabled: true,
              schedule_time: backupSchedule.schedule_time
            })
              .then(function (response) {
                if (response.data.success === 'true') {
                  backupSchedule = response.data.backup_schedule[0]
                  commit(types.ADD_BACKUP_SCHEDULE, backupSchedule)
                  router.push({ name: 'AdminBARScheduleIndex' })
                } else {
                  alert(response.data.message)
                }
              })
          } else {
            api.instance.put('backup_schedules/' + backupSchedule.backup_schedule_id, backupSchedule)
              .then(function (response) {
                if (response.data.success === 'true') {
                  backupSchedule = response.data.backup_schedule[0]
                  let tempScheduleTime = moment(backupSchedule.schedule_time, [twentyFourHourFormat])
                  backupSchedule.schedule_time = tempScheduleTime.format(twelveHourFormat)
                  commit(types.EDIT_BACKUP_SCHEDULE, backupSchedule)
                  router.push({ name: 'AdminBARScheduleIndex' })
                } else {
                  alert(response.data.message)
                }
              })
          }
        } else {
          alert('Incorrect time format.')
        }
      } else {
        alert('Please select a location.')
      }
    } else {
      alert('Name is a required field.')
    }
  },
  deleteBackupSchedule ({ commit }, backupSchedule) {
    api.instance.delete('backup_schedules/' + backupSchedule.backup_schedule_id)
      .then(function (response) {
        commit(types.DELETE_BACKUP_SCHEDULE, backupSchedule)
      })
  },
  performBackup ({ commit }, backup) {
    api.instance.post('backup', backup)
      .then(function (response) {
        if (response.data.success === 'true') {
          alert(response.data.message)
        } else {
          alert(response.data.message)
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  uploadBackupFile ({ commit }, { fileImport, onProgress }) {
    let formData = new FormData()
    formData.append('backup_file', fileImport.file)

    api.instance.post('restore', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: function (progressEvent) {
        let percentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total))

        if (onProgress) {
          onProgress(percentage)
        }
      }
    })
      .then(function (response) {
        if (response.data.success === 'true') {
          alert(response.data.message)
        } else {
          alert(response.data.message)
        }
      })
  }
}

const mutations = {
  [types.RECEIVE_BACKUP_FREQUENCIES] (state, backupFrequencies) {
    state.backup_frequencies = backupFrequencies
  },
  [types.RECEIVE_BACKUP_LOCATION_TYPES] (state, backupLocationTypes) {
    state.backup_location_types = backupLocationTypes
  },
  [types.RECEIVE_BACKUP_LOCATION] (stte, backupLocation) {
    state.backup_location = backupLocation
  },
  [types.RECEIVE_BACKUP_LOCATIONS] (state, backupLocations) {
    state.backup_locations = backupLocations
    state.backup_locations_received_timestamp = Date.now()
  },
  [types.ADD_BACKUP_LOCATION] (state, backupLocation) {
    state.backup_locations.push(backupLocation)
  },
  [types.EDIT_BACKUP_LOCATION] (state, backupLocation) {
    let backupLocationToEdit = state.backup_locations.find(
      function (ele) {
        if (ele.backup_location_id === backupLocation.backup_location_id) {
          return true
        }
      }
    )
    let index = state.backup_locations.indexOf(backupLocationToEdit)
    state.backup_locations[index] = backupLocation
  },
  [types.DELETE_BACKUP_LOCATION] (state, backupLocation) {
    let backupLocationToDelete = state.backup_locations.find(
      function (ele) {
        if (ele.backup_location_id === backupLocation.backup_location_id) {
          return true
        }
      }
    )
    let index = state.backup_locations.indexOf(backupLocationToDelete)
    state.backup_locations.splice(index, 1)
  },
  [types.RECEIVE_BACKUP_SCHEDULE] (state, backupSchedule) {
    state.backup_schedule = backupSchedule
  },
  [types.RECEIVE_BACKUP_SCHEDULES] (state, backupSchedules) {
    state.backup_schedules = backupSchedules
    state.backup_schedules_received_timestamp = Date.now()
  },
  [types.ADD_BACKUP_SCHEDULE] (state, backupSchedule) {
    state.backup_schedules.push(backupSchedule)
  },
  [types.EDIT_BACKUP_SCHEDULE] (state, backupSchedule) {
    let backupScheduleToEdit = state.backup_schedules.find(
      function (ele) {
        if (ele.backup_schedule_id === backupSchedule.backup_schedule_id) {
          return true
        }
      }
    )
    let index = state.backup_schedules.indexOf(backupScheduleToEdit)
    state.backup_schedules[index] = backupSchedule
  },
  [types.DELETE_BACKUP_SCHEDULE] (state, backupSchedule) {
    let backupScheduleToDelete = state.backup_schedules.find(
      function (ele) {
        if (ele.backup_schedule_id === backupSchedule.backup_schedule_id) {
          return true
        }
      }
    )
    let index = state.backup_schedules.indexOf(backupScheduleToDelete)
    state.backup_schedules.splice(index, 1)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
